module.exports = __webpack_public_path__ + "static/stb_separator-structure-a8fbac6abda13b06aacb47f044a46938.jpg";